import React, { useEffect, useState } from "react";
import { Table as AntTable, Button, Col, message, Pagination, Popconfirm, Row, notification, Form, Modal, Switch, Card } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { Link, useNavigate } from "react-router-dom";
import { components, getRowClassName } from "../../utils/utils";
import IMAGES from "../../const/Image";
import Search from "antd/es/input/Search";
import { FaSliders } from "react-icons/fa6";

import { Space, Tooltip } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import DashboardRequest from "./DashboardRequest";

import { Tabs } from 'antd';
import '../../assests/css/dashboard.css'

const onChange = (key) => {
  console.log(key);
};

// const confirm = (e) => {
//   console.log(e);
//   message.success('Deleted!');
// };


export default function Dashboard() {

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { confirm } = Modal;
  const showConfirm = Modal.confirm;
  const [labList, setLabList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customServiceRequestList, setCustomServiceRequestList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const initialFilter = { page: 1 };
  const [filter, setFilter] = useState(initialFilter);

  const [dashboardData, setDashboardData] = useState({
    users: 0,
    salon: 0,
    appointments: 0,
    upcommingAppointments: 0,
    canceledAppointments: 0,
    completedAppointments: 0,
  });


  const columns = () => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: '60px',
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Salon ID",
      dataIndex: "salonId",
      key: "salonId",
      // width: '200px'
    },
    {
      title: "Salon Name",
      dataIndex: "salonName",
      key: "salonName",
      // width: '200px'
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      key: "ownerName",
      // width: '200px'
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      // width: '200px'
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      // width: '200px'
    },


    {
      title: "Status",
      dataIndex: "status",
      // width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Approved"
          unCheckedChildren="Rejected"
          onChange={(checked) => handleSalonStatus(checked, item)}
        />
      ),
    },
    {
      title: "Salon Type",
      dataIndex: "salonType",
      key: "salonType",
      // width: '160px',
      render: (value) => {
        if (value === 0) return "Men";
        if (value === 1) return "Women";
        if (value === 2) return "Unisex";
      },
    },
    {
      title: "Service Type",
      dataIndex: "serviceType",
      key: "serviceType",
      // width: '160px',
      render: (value) => {
        if (value === 0) return "Home ";
        if (value === 1) return "Salon ";
        if (value === 2) return "Both"
      }
    },
    {
      title: "Service KM",
      dataIndex: "serviceKm",
      key: "serviceKm",
      // width: '160px'
    },

    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      // width: '200px',
      render: ( _, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span className="action-icon-bg" onClick={() =>navigate(`/salons/details/${record.salonId}`)}>
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>
          <Tooltip title="Edit Details">
            <span className="action-icon-bg" onClick={()=>navigate("/salons/edit")}>
              <img src={IMAGES.EditIcon} />
            </span>
          </Tooltip>
          <Popconfirm
            title="Delete the task"
            description="Are you sure to delete this task?"
            onConfirm={confirm}
            okText="Yes"
            cancelText="No"
          >
            <span className="action-icon-bg">
              <img src={IMAGES.DeleteIcon} alt="" />
            </span>
          </Popconfirm>
        </Space>
      ),
    },

  ];

  const customerColumns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: '60px',
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",

    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (gender) => (
        gender === 0 ? "Male" : gender === 1 ? "Female" : "Unisex"
      )
    },
    {
      title: "Address",
      dataIndex: "userAddress",
      key: "userAddress",
      render: (userAddress) =>
        userAddress ? `${userAddress.city}, ${userAddress.state}` : "N/A",
    },
    // {
    //   title: "Password",
    //   dataIndex: "password",
    //   key: "password",
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Mobile Verified",
      dataIndex: "isMobileVerified",
      key: "isMobileVerified",
      render: (isMobileVerified) => (
        isMobileVerified === 0 ? "No" : "Yes"
      )
    },
    {
      title: "Email Verified",
      dataIndex: "isEmailVerified",
      key: "isEmailVerified",
      render: (isEmailVerified) => (
        isEmailVerified === 0 ? "No" : "Yes"
      )
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span className="action-icon-bg" onClick={() => navigate(`/customers/details/${record.userId}`)}>
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>
          {/* <Tooltip title="Edit Details">
            <span className="action-icon-bg" onClick={()=> navigate(`/customers/edit`)}>
              <img src={IMAGES.EditIcon} />
            </span>
          </Tooltip> */}
          {/* <Popconfirm
            title="Delete the task"
            description="Are you sure to delete this task?"
            onConfirm={confirm}
            okText="Yes"
            cancelText="No"
          >
            <span className="action-icon-bg">
              <img src={IMAGES.DeleteIcon} alt="" />
            </span>
          </Popconfirm> */}
        </Space>
      ),
    },
    // Add other columns as needed
  ];

  const CustomServiceRequestColumns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Category Name",
      dataIndex: "saloncategory",
      key: "categoryTitle",
      render: (saloncategory) =>
        saloncategory && saloncategory.category
          ? saloncategory.category.categoryTitle
          : "N/A",

    },
    {
      title: "Salon Name",
      dataIndex: "salon",
      key: "salonName",
      render: (salon) =>
        salon ? `${salon.salonName}` : "N/A",
    },
    {
      title: "Service Name",
      dataIndex: "serviceName",
      key: "serviceName",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Approved"
          unCheckedChildren="Rejected"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },


    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/dashboard/custom-service-requet/view/${record.salonId}`)}
            >
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>

        </Space>
      ),
    },
    // Add other columns as needed
  ];


  // const fetchSalonList = () => {
  //   setLoading(true);
  //   SalonRequest.salonList()
  //     .then((response) => {
  //       console.log(response)
  //       // const rawData = response?.data?.data?.list || [];
  //       // console.log(rawData)
  //       // const totalCount = response?.data?.total || 0;
  //       //setLabList(rawData)
  //       //setTotalRecords(totalCount)
  //     })
  //     .catch((error) => {
  //       message.error("Failed to fetch salon list")
  //       console.log("error", error)
  //     })
  //     .finally(() => {
  //       setLoading(false)
  //     })

  // }

  useEffect(() => {
    //fetchSalonList();
  },[filter])

  // const fetchCustomerList = () => {
  //   setLoading(true);
  //   CustomerRequest.customerList(filter)
  //     .then((response) => {

  //       const rawData = response?.data?.data?.data || [];
  //       console.log("rawdata", rawData)
  //       const totalCount = response?.data?.total || 0;
  //       setCustomerList(rawData);
  //       setTotalRecords(totalCount);
  //     })
  //     .catch((error) => {
  //       message.error("Failed to fetch customers.");
  //       console.error(error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   fetchCustomerList();
  // }, [filter]);


  // const fetchServiceList = () => {
  //   setLoading(true);
  //   // CategoryRequest.categoryList(searchFilter.page, searchFilter.limit, searchFilter.title)
  //   DashboardRequest.customerRequestList()
  //     .then((response) => {
  //       const rawData = response?.data?.data || [];
  //       console.log("rawdata", rawData)
  //       const totalCount = response?.data?.total || 0;
  //       setCustomServiceRequestList(rawData);
  //       setTotalRecords(totalCount);
  //     })
  //     .catch((error) => {
  //       message.error("Failed to fetch customers.");
  //       console.error(error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   fetchServiceList();
  // }, [filter]);



  const fetchDashboardCounter = () => {
    setLoading(true);
    DashboardRequest.dashboardCounter()
      .then((response) => {
        const data = response?.data?.data?.totalCounts || {};
        console.log(data);
        setDashboardData({
          users: data.users || 0,
          salon: data.salon || 0,
          appointments: data.appointments || 0,
          upcommingAppointments: data.upcommingAppointments || 0,
          canceledAppointments: data.canceledAppointments || 0,
          completedAppointments: data.completedAppointments || 0,
        });
      })
      .catch((error) => {
        message.error("Failed to fetch Counter List");
        console.error("Error fetching dashboard data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   fetchDashboardCounter();
  // }, []);


  const handleStatusChange = (checked, item) => {
    confirm({
      title: `Are you sure you want to ${checked ? "approve" : "reject"} this service?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        DashboardRequest.UpdateServiceReq({
          id: item.id,
          status: checked ? "1" : "0",
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.id === item.id ? { ...el, status: checked ? 1 : 0 } : el
                )
              );
              //fetchServiceList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const handleSalonStatus = (checked, item) => {

    // confirm({
    //   title: `Are you sure you want to ${checked ? "approve" : "reject"} this salon?`,
    //   okText: "Yes",
    //   okType: "danger",
    //   cancelText: "No",
    //   onOk() {
    //     setLoading(true);
    //     SalonRequest.updateSalonStatus({
    //       status: checked ? 1 : 0,
    //       salonId: item.salonId,
    //     })
    //       .then((res) => {
    //         if (res && res.status === 200) {
    //           notification.success({
    //             message: "Status updated successfully",
    //           });
    //           setLabList((prevList) =>
    //             prevList.map((el) =>
    //               el.salonId === item.salonId ? { ...el, status: checked ? "1" : "0" } : el
    //             )
    //           );
    //           fetchSalonList();
    //         } else {
    //           notification.error({
    //             message: "Failed to update status",
    //           });
    //         }
    //       })
    //       .catch(() => {
    //         notification.error({
    //           message: "Failed to update status",
    //         });
    //       })
    //       .finally(() => {
    //         setLoading(false);
    //       });
    //   },
    // });
  };
  return (
    <>
      <div className="content">
        <h1><br /><br />Welcome to Administrator<br /></h1>
      </div>
      {/* <div>

        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col style={{ marginBottom: "1rem" }}>
            <h1 className=" app-heading-med"> Dashboard </h1>
          </Col>
        </Row>
        <div className='dashboard-card'>
          <Row gutter={16}>
            <Col span={8} className='count-card' >
              <Card title="Total Customers" className='custom-card' onClick={() => navigate("/customers")}>
                <div className="card-number">{dashboardData.users}</div>
              </Card>
            </Col>
            <Col span={8} className='count-card'>
              <Card title="Total Salons" className='custom-card' onClick={() => navigate("/salons")}>
                <div className="card-number">{dashboardData.salon }</div>
              </Card>
            </Col>
            <Col span={8} className='count-card'>
              <Card title="Total Appointments" className='custom-card' onClick={() => navigate("/appoinments", { state: { activeTab: '4' } })}>
                <div className="card-number">{dashboardData.appointments}</div>
              </Card>
            </Col>
            <Col span={8} className='count-card'>
              <Card title="Completed Appointments" className='custom-card' onClick={() => navigate("/appoinments", { state: { activeTab: '4' } })}>
                <div className="card-number">{dashboardData.completedAppointments}</div>
              </Card>
            </Col>
            <Col span={8} className='count-card'>
              <Card title="Upcoming Appointments" className='custom-card' onClick={() => navigate("/appoinments", { state: { activeTab: '1' } })}>
                <div className="card-number">{dashboardData.upcommingAppointments}</div>
              </Card>
            </Col>
            <Col span={8} className='count-card'>
              <Card title="Cancelled Appointments" className='custom-card' onClick={() => navigate("/appoinments", { state: { activeTab: '3' } })}>
                <div className="card-number">{dashboardData.canceledAppointments}</div>
              </Card>
            </Col>
          </Row>

        </div>
      </div> */}

      {/* <div className="">


        <Row gutter={[8, 8]} justify="space-between" align="middle" style={{ marginTop: "2rem", marginBottom: "1rem" }}>


          <Col>
            <h3 className=" dashboard-heading app-heading-med"> Latest Salons </h3>
          </Col>
          <Col>
            <Button type="primary" style={{ marginBottom: "1rem" }} onClick={() => navigate("/salons")}>View Details</Button>
          </Col>

        </Row>

      </div> */}


      {/* <div style={{}}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          // columns={columns}
          loading={loading}
          dataSource={labList}
          // pagination={false}
          scroll={{ x: "max-content" }}
        />
      </div> */}

      {/* <Row gutter={[8, 8]} justify="space-between" align="middle">
        <Col style={{ marginTop: "1rem" }}>
          <h3 className=" dashboard-heading app-heading-med"> Custom Service Request </h3>
        </Col>
        <Col>
          <Button type="primary" style={{ marginBottom: "1rem" }} onClick={() => navigate("/dashboard/custom-service-request")}>View Details</Button>
        </Col>

      </Row> */}

      {/* <div style={{ marginTop: '20px' }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={CustomServiceRequestColumns(navigate)}
          loading={loading}
          dataSource={customServiceRequestList}
        />
      </div> */}

      {/* <Row gutter={[8, 8]} justify="space-between" align="middle" style={{ marginBottom: "1rem" }}>
        <Col style={{ marginTop: "1rem" }}>
          <h3 className=" dashboard-heading app-heading-med"> New Customers </h3>
        </Col>
        <Col>
          <Button type="primary" style={{ marginBottom: "1rem" }} onClick={() => navigate("/customers")}>View Details</Button>
        </Col>

      </Row> */}

      {/* <div>
        <Table
          size="middle"
          width="auto"

          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={customerColumns(navigate)}
          loading={loading}
          dataSource={customerList}
        />
      </div> */}

    </>
  )
}

